import React from 'react';
import Watermark from '@/components/remotion/Watermark';
import type { WatermarkConfig } from '@/lib/campaign-watermark-types';
import type { WatermarkPosition } from '@/lib/watermark/watermarkPosition';
import { AutoclipperWatermark } from './AutoclipperWatermark';

/** Preview hosts: a campaign watermark wins (admin placement, frame 0);
 *  otherwise the free-plan animated watermark at the user's position. */
export const ClipWatermark: React.FC<{
  campaignWatermark?: WatermarkConfig;
  showWatermark?: boolean;
  position?: WatermarkPosition | null;
}> = ({ campaignWatermark, showWatermark, position }) => {
  if (campaignWatermark) return <Watermark config={campaignWatermark} />;
  if (showWatermark) return <AutoclipperWatermark position={position} />;
  return null;
};
